export const en = {
    'access-suggest-placeholder': 'Add user or group',
    'action-owner': 'Make owner',
    'action-remove': 'Delete',
    'action-select-me': 'Add me',
    active: 'Active',
    address: 'Redirect page address',
    'all-people-external': 'All employees',
    'all-people-hint-external': 'The page is available to all employees of the organization.',
    'all-people-hint-internal': 'The page is available to all staff employees.',
    'all-people-internal': 'All staff employees',
    author: 'Author',
    'co-author': 'Co-author',
    'comments-on-page': 'Comments on the page',
    'confirm-delete-cancel': 'Cancel',
    'confirm-delete-message': 'You are about to restrict your own access to the page. If you confirm this action, you will no longer be able to view or edit it.',
    'confirm-delete-save': 'Yes, proceed',
    'confirm-delete-title': 'Loss of access',
    departments: 'Departments',
    'dialog-apply': 'Save',
    'dialog-cancel': 'Cancel',
    group: 'Group',
    'hint-message': ' You can redirect users from this page to another one',
    'hint-message-collab': 'Edit the page with other users and see the changes made by your colleagues in real time',
    'hint-message-redirect': 'You can redirect users from this page to another one',
    'how-to-request-rights': 'How to request access',
    'incorrect-address-message': 'To see full page address, enter a valid value in the {{address}} field.',
    'invalid-custom-acl-b2b': 'If the "Some employees" access type is selected, specify at least one user (besides the authors) or department.',
    'invalid-custom-acl-intranet': 'If the "Some employees" access type is selected, specify at least one user (besides the authors), department, service, or group.',
    'label-collab': 'Collab mode',
    'like-parent': 'Same as parent page',
    'new-address': 'Full redirect address',
    'new-address-hint': 'To see full address, fill in the {{address}} field.',
    'only-authors': 'Only authors',
    'only-authors-hint': 'Only its authors can edit the page',
    owner: 'Owner',
    'owner-tooltip': 'This user is displayed as the author above the page title.',
    'parent-access-hint-1': 'The page is available to the same people that have access to',
    'parent-access-hint-2': 'the parent page.',
    placeholder: 'User name or login',
    'redirect-title': 'Redirection',
    'redirect-update-error': 'Invalid Redirect page address value',
    'request-author-role': 'Become author',
    'request-error': 'Error sending request',
    'request-success': 'Request sent to page authors',
    'request-success-granted': 'Author role granted successfully',
    'request-success-sent': 'Request already sent to page authors',
    save: 'Save',
    'search-filters-section-current-page': 'current',
    services: 'Services',
    'some-people': 'Some employees',
    'tab-title-access': 'Access rights',
    'tab-title-authors': 'Authors',
    'tab-title-collab': 'Collab mode',
    'tab-title-comments': 'Comments',
    'tab-title-common': 'General settings',
    'tab-title-redirect': 'Redirection',
    teams: 'Teams',
    title: 'Page settings',
    'update-error-general': 'Couldn\'t save access settings',
    'update-error-no-access-rights': 'You don\'t have enough rights to grant external employees access to the page.',
    'update-settings-error-general': 'Could not save settings',
    'update-success': 'Settings updated',
    'wiki-groups': 'Wiki groups'
};
